// extracted by mini-css-extract-plugin
export default {"sidebar":"IntegrationSidebar_sidebar__PiMIz","sidebar__wrapper":"IntegrationSidebar_sidebar__wrapper__WiNng"};